import * as minio from "minio";

// libs and consts
import Translation from "libs/Translation";
import { apiConfig, appConfig } from "configs";
import ToastManager from "libs/ToastManager";

const Util = {
  serialize(obj, prefix) {
    const str = [];
    Object.keys(obj).forEach((p) => {
      const k = prefix ? `${prefix}[${p}]` : p;
      const v = obj[p];

      if (encodeURIComponent(v) !== null && encodeURIComponent(v) !== "") {
        str.push(
          v !== null && typeof v === "object"
            ? this.serialize(v, k)
            : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
        );
      }
    });

    return str.join("&");
  },

  setFutureTimer: (seconds) => {
    const now = new Date();
    return now.getTime() + seconds * 1000;
  },

  thousandSeparator(n, sep) {
    var sRegExp = new RegExp("(-?[0-9]+)([0-9]{3})"),
      sValue = n + "";

    if (sep === undefined) {
      sep = ",";
    }
    while (sRegExp.test(sValue)) {
      sValue = sValue.replace(sRegExp, "$1" + sep + "$2");
    }
    return sValue;
  },

  normalizedFileName: (fileType, fileName) => {
    let type = fileType?.split("/")[1].toUpperCase();
    if (type?.includes("WORD")) {
      type = "WORD";
    }

    const date = Math.round(new Date().getTime() / 1000);
    const name = `${date}_others_${type}_${fileName}`;

    return name;
  },

  replaceMultiple: (text) => {
    const characters = [
      { "/": "-" },
      { "@": "-" },
      { "#": "-" },
      { _: "-" },
      { $: "-" },
      { "%": "-" },
      { "^": "-" },
      { "&": "-" },
      { "*": "-" },
      { "(": "-" },
      { ")": "-" },
      { "{": "-" },
      { "}": "-" },
      { "[": "-" },
      { "]": "-" },
      { "+": "-" },
      { "=": "-" },
      { ",": "-" },
      { "~": "-" },
      { "!": "-" },
      { "?": "-" },
      { "'": "-" },
      { '"': "-" },
      { " ": "-" },
    ];

    for (const [i, each] of characters.entries()) {
      const previousChar = Object.keys(each);
      const newChar = Object.values(each);

      text = text?.replaceAll(previousChar, newChar);
    }

    return text;
  },

  checkFileValidation: (size, fileName, webConfig) => {
    const regex = /^[A-Za-z0-9.-]+$/;

    if (!regex.test(fileName)) {
      ToastManager.show(Translation.t("text.file-name-limitation"), webConfig);
      return false;
    }
    if (size > 50e6) {
      ToastManager.show(
        Translation.t("text.upload-file-size-limit"),
        webConfig
      );
      return false;
    } else {
      return true;
    }
  },

  filterTodayAppts: (data) => {
    let list = [];
    const day = new Date().toISOString();

    data.forEach((d) => {
      if (
        Translation.dateWithoutTime(d.StartTime) ===
        Translation.dateWithoutTime(day)
      )
        list.push(d);
    });
    return list;
  },

  sortingAppts: (data, id) => {
    let result = [];
    if (id === 0) {
      result = data.sort(
        (a, b) => new Date(b.StartTime) - new Date(a.StartTime)
      );
    } else {
      result = data.sort(
        (a, b) => new Date(a.StartTime) - new Date(b.StartTime)
      );
    }
    return result;
  },

  bytesForHuman(bytes, decimals = 2) {
    let units = ["B", "KB", "MB", "GB", "TB", "PB"];

    let i = 0;

    for (i; bytes > 1024; i++) {
      bytes /= 1024;
    }

    return parseFloat(bytes.toFixed(decimals)) + units[i];
  },

  convertToEngNum(value = "") {
    const phone = value.replace(/([۰-۹])/g, (token) =>
      String.fromCharCode(token.charCodeAt(0) - 1728)
    );
    return phone;
  },

  fixPhone(value) {
    let phone = value;
    if (phone.charAt(0) === "0") {
      phone = phone.slice(1);
    }
    return phone;
  },

  validatePhone(value) {
    let valid = true;
    if (value.charAt(0) === "0" && value.length !== 11) {
      valid = false;
    } else if (value.charAt(0) === "9" && value.length !== 10) {
      valid = false;
    } else if (value.charAt(0) !== "9" && value.charAt(0) !== "0") {
      valid = false;
    }
    return valid;
  },

  validateNationalCode(value) {
    if (!/^\d{10}$/.test(value)) return false;
    const check = +value[9];
    const sum =
      value
        .split("")
        .slice(0, 9)
        .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
    return sum < 2 ? check === sum : check + sum === 11;
  },

  validateName(value) {
    const isWhitespaceString = !/\S/.test(value);

    let valid = true;
    if (isWhitespaceString || value.length === 1) {
      valid = false;
    }
    return valid;
  },

  async connectToMinio(bucketName, objectName, setting) {
    const minioClient = new minio.Client({
      endPoint: "s3.vclinic.io",
      port: 9000, // or 443 if using SSL
      useSSL: false,
      accessKey: "hooshmand",
      secretKey: "Hoshmand404@",
    });

    minioClient.presignedGetObject(
      bucketName,
      objectName,
      168 * 60 * 60,
      function (err, presignedUrl) {
        if (err) return console.log(err);
        setting(presignedUrl);
      }
    );
  },

  prepareSeo: (page, props, seo = []) => {
    let title = Translation.t(`title.${page}`, props);
    let description = Translation.t(`description.${page}`, props);
    let addTitlePostfix = true;
    const additionalMetaTags = [];

    seo.forEach((s) => {
      const key = Object.keys(s)[0];
      if (key === "title") {
        title = s.title;
        addTitlePostfix = false;
      } else if (key === "description") {
        description = s.description;
      } else {
        additionalMetaTags.push({ [key]: s[key] });
      }
    });

    return {
      seo: {
        title,
        description,
        additionalMetaTags,
      },
      addTitlePostfix,
    };
  },

  makeWebSiteJsonLd: () => ({
    "@context": "https://www.schema.org",
    "@type": "WebSite",
    url: "https://www.vclinic.io/",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate:
          "https://www.vclinic.io/explore/doctors?name={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  }),

  makeOrganizationJsonLd: () => ({
    "@context": "http://www.schema.org",
    "@type": "Organization",
    name: Translation.t('title.default"'),
    url: "https://www.vclinic.io",
    sameAs: [
      "https://www.linkedin.com/company/vclinic/",
      "https://www.instagram.com/vclinic.io/",
      "https://wa.me/989011743193",
    ],
    address: {
      "@type": "PostalAddress",
      addressCountry: Translation.t("label.iran"),
      addressRegion: Translation.t("label.tehran"),
      streetAddress: Translation.t("text.footer-address"),
    },
    telephone: "+2126329244,+2188637593,+2186094188",
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+2188637593",
        contactType: "customer service",
      },
    ],
    logo: "",
    alternateName: "vclinic",
  }),

  makeDrProfileJsonLd: (doctor) => ({
    "@context": "http://www.schema.org",
    "@type": "Physician",
    image: `${appConfig.site_url}${doctor?.Image}`,
    name: `${doctor?.Label} ${doctor?.FullName}`,
    address: {
      addressCountry: "IR",
      streetAddress:
        doctor?.HealthProviderProfiles?.length &&
        doctor.HealthProviderProfiles[0].Address,
      addressLocality: "IRAN",
      addressRegion: "IRAN",
      postalCode: "0",
    },
    potentialAction: {
      "@type": "ReserveAction",
      target: {
        "@type": "EntryPoint",
        actionPlatform: "http://www.schema.org/DesktopWebPlatform",
        inLanguage: "fa-IR",
        url: `https://www.vclinic.io/dr/${doctor?.Slug}`,
      },
      result: {
        "@type": "Reservation",
        name: "Appointment",
      },
    },
    memberOf: {
      url: "https://www.vclinic.io",
    },
    location: {
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          doctor?.HealthProviderProfiles?.length &&
          doctor.HealthProviderProfiles[0].Address,
        addressLocality: "IRAN",
        addressRegion: "IRAN",
        postalCode: "0",
        addressCountry: {
          name: "IR",
        },
      },
    },
  }),

  makeCenterProfileJsonLd: (center, url, city) => ({
    "@context": "http://www.schema.org",
    "@type": "Person",
    jobTitle: "physician",
    name: center.Name,
    telephone: center?.phoneNumber,
    image: center?.profileImage
      ? center.profileImage?.fileUrl
      : "https://vclinic.io/images/center/avatar.jpeg",
    url: url,
    address: {
      "@type": "PostalAddress",
      addressCountry: { "@type": "Country", name: "IR" },
      addressLocality: city,
      addressRegion: city,
      streetAddress: center?.Address,
    },
  }),
};

export default Util;
